import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { num, run, useLoad } from "../lib/util";
import { Btn, Card, Field, Input, cellCls } from "../components/kit";
import { useSchool } from "./ctx";

const MODS = [["eja", "Ensino de jovens e adultos (turno da noite)"], ["medio", "Ensino médio (manhã, tarde e integral)"], ["total", "Total"]];
const COLS = [["matriculas", "Matrículas"], ["media", "Nº médio de atend. diários"], ["dias", "Nº de dias de merenda"], ["refeicoes", "Total de refeições"]];

export default function MapInfo() {
  const { month, stock } = useSchool();
  const [doc, reload] = useLoad(async () => (await api.get(`/s/map-info/${month}`)).data, [month]);
  const [f, setF] = useState(null);
  const [filling, setFilling] = useState(false);
  const fill = async () => {
    setFilling(true);
    const ok = await run(() => api.post(`/s/map-info/${month}/from-map`), "Dados informativos preenchidos a partir do mapa");
    setFilling(false);
    if (ok) reload();
  };
  useEffect(() => {
    setF(doc);
  }, [doc]);
  if (!f) return null;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const setMod = (m, k, v) => setF({ ...f, capa_override: { ...f.capa_override, [m]: { ...(f.capa_override?.[m] || {}), [k]: num(v) } } });
  const save = async () => {
    const body = { ...f, preparadoras: f.preparadoras === "" || f.preparadoras == null ? null : parseInt(f.preparadoras, 10),
      dias_letivos: f.dias_letivos === "" || f.dias_letivos == null ? null : parseInt(f.dias_letivos, 10), version: f.is_default ? null : f.version };
    ["id", "school_id", "month", "created_at", "updated_at", "is_default", "capa_auto", "capa_final", "capa_missing"].forEach((k) => delete body[k]);
    if (await run(() => api.put(`/s/map-info/${month}`, body), "Dados do ofício e da capa salvos")) reload();
  };
  return (
    <Card className="space-y-4" data-testid="map-info-card">
      <div className="flex flex-wrap justify-between gap-3">
        <div>
          <h3 className="font-heading font-bold">Ofício e capa do mapa do mês</h3>
          <p className="text-xs text-slate-500">Endereço, telefone, UA, DRA, município, diretor, horários e preparadoras podem ser lidos do mapa enviado em Documentos. Dias letivos: {stock ? Object.keys(stock.days).length : "…"} pelo calendário (preencha só para substituir).</p>
        </div>
        <Btn variant="outline" data-testid="mi-fill-from-map" disabled={filling} onClick={fill}>{filling ? "Lendo o mapa…" : "Preencher a partir do mapa"}</Btn>
      </div>
      <div className="grid md:grid-cols-3 gap-3">
        <Field label="Ofício nº"><Input data-testid="mi-oficio-input" value={f.oficio_numero || ""} placeholder="ex.: 16/2026" onChange={set("oficio_numero")} /></Field>
        <Field label="Destino" className="md:col-span-2"><Input data-testid="mi-destino-input" value={f.destino || ""} onChange={set("destino")} /></Field>
        <Field label="Texto do ofício" className="md:col-span-3"><textarea data-testid="mi-corpo-input" rows={2} className="w-full rounded-lg border border-slate-300 p-2 text-sm" value={f.corpo || ""} onChange={set("corpo")} /></Field>
        <Field label="Horário parcial"><Input data-testid="mi-horario-input" value={f.horario_parcial || ""} placeholder="ex.: 08:00 às 12:00; 13:00 às 17:30" onChange={set("horario_parcial")} /></Field>
        <Field label="Horário ampliado"><Input value={f.horario_ampliado || ""} onChange={set("horario_ampliado")} /></Field>
        <Field label="Horário integral"><Input value={f.horario_integral || ""} onChange={set("horario_integral")} /></Field>
        <Field label="Programa Mais Educação"><Input value={f.mais_educacao || ""} onChange={set("mais_educacao")} /></Field>
        <Field label="Nº de preparadoras de refeição"><Input data-testid="mi-preparadoras-input" type="number" min="0" value={f.preparadoras ?? ""} onChange={set("preparadoras")} /></Field>
        <Field label="Dias letivos (substituir)"><Input type="number" min="0" value={f.dias_letivos ?? ""} onChange={set("dias_letivos")} /></Field>
      </div>
      <div>
        <h4 className="font-heading font-semibold text-sm">Números do mapa (calculados automaticamente)</h4>
        <p className="text-xs text-slate-500">Calculados pelos comensais do Cardápio diário: manhã e tarde 2 refeições, integral 3 e noite 1 por comensal ao dia. Em cinza o valor automático; digite só para corrigir e apague para voltar ao automático.</p>
      </div>
      {!!f.capa_missing?.length && <div data-testid="mi-capa-missing" className="rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">Alguns números ficam em branco porque falta: {f.capa_missing.join("; ")}.</div>}
      <div className="overflow-x-auto">
        <table className="w-full mapia-table text-sm border rounded-lg">
          <thead><tr><th>Modalidade de ensino</th>{COLS.map(([k, l]) => <th key={k}>{l}</th>)}</tr></thead>
          <tbody>
            {MODS.map(([m, l]) => (
              <tr key={m}>
                <td className="font-semibold">{l}</td>
                {COLS.map(([k]) => <td key={k}><input data-testid={`mi-${m}-${k}`} type="number" step="any" min="0" className={cellCls} placeholder={(() => { const a = m !== "total" && k !== "media" ? doc?.capa_auto?.[m]?.[k] : doc?.capa_final?.[m]?.[k]; return a != null ? String(a) : "—"; })()} value={f.capa_override?.[m]?.[k] ?? ""} onChange={(e) => setMod(m, k, e.target.value)} /></td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Btn data-testid="mi-save-button" onClick={save}>Salvar dados do mês</Btn>
    </Card>
  );
}
